export const selloutOrigin = [
  'ospharm',
  'offisante',
  'santestat',
  'group',
  'faks',
  'document_ai',
  'document_highco',
] as const;
export type SelloutOrigin = (typeof selloutOrigin)[number];

export const isSelloutOriginFromDocument = (origin: SelloutOrigin) =>
  origin === 'document_ai' || origin === 'document_highco';

export const isSelloutOriginFromAi = (origin: SelloutOrigin) => origin === 'document_ai';

export interface SelloutItem {
  id: number;
  data_reception_date: string;
  ean: string;
  quantity: number;
  turnover_including_tax_in_cents: number;
  trades_requirements_instances_id: number;
  origin: SelloutOrigin;
  quantity_from_origin: number | null;
  quantity_from_pharmacist: number | null;
  quantity_from_validator: number | null;
  turnover_including_tax_in_cents_from_origin: number | null;
  turnover_including_tax_in_cents_from_pharmacist: number | null;
  turnover_including_tax_in_cents_from_validator: number | null;
}
